'use client';

import { FC, useEffect, useState } from 'react';
import EditIcon from '@/components/Icon/EditIcon';
import useAllertEdit from '@/hooks/useAllertEdit';
import { EditButtonProps } from './types';
import useIsAdmin from '@/hooks/useIsAdmin';

// TODO: if will have issue with performace, try to do this component on server side
const EditButton: FC<EditButtonProps> = ({ id, recordId = '0', slug = '', url = '', page = '', className }) => {
  const [editLink, setEditLink] = useState<string>('');
  const { isAdmin } = useIsAdmin();

  const getEditUrl = async () => {
    const editUrl = await useAllertEdit(recordId, slug, isAdmin, url, page);
    setEditLink(editUrl ?? '');
  };

  useEffect(() => {
    getEditUrl();
  }, [isAdmin]);

  return editLink && isAdmin && <EditIcon id={id} url={editLink} className={className} />;
};

export default EditButton;
